// extracted by mini-css-extract-plugin
export default {"wrapper":"qvsDYg","wrapperMobile":"HgWYBn","parts":"MsiiDy","partOne":"PcyFdt","partTwo":"bCKTML","title":"i1R_SX","subTitle":"FX_7U5","value":"uWwOse"};